<template>
  <div class="authnet-page">
    <header class="authnet-header">
      <img class="header-logo" :src="'/images/brand-assets/authnet-lp_logo.jpg'">
      <img class="header-image" :src="'/images/brand-assets/authnet-lp_header.jpg'">
    </header>
    <main class="credit-app-main">
      <el-dialog title="Error" :visible.sync="errors" width="30%" @close="redirectAfterClosed">
        <div class="error-dialog-body">{{ errors }}</div>
      </el-dialog>

      <div class="card card--form">
        <header class="card__header">
          <p>Thank you for completing the previous form.<br>
            In order to proceed with making a secure Credit Card payment, please fill out the information below.</p>
        </header>

        <form ref="formElement" @submit.prevent="submit" autocomplete="off">
          <section class="card__body">
            <p class="customer-info">PAYMENT INFORMATION &nbsp<small>*Mandatory field </small></p>
            <div>
              <div class="float-child">
                <SaxxText
                    name="amount"
                    size="50"
                    :form="formName"
                    :hide-label="true"
                    :placeholder="placeholderCurrencyText"
                    required
                />
              </div>
              <div class="float-child">
                <SaxxText
                    name="invoiceNumber"
                    size="150"
                    :form="formName"
                    :hide-label="true"
                    placeholder="Invoice Number*"
                    required
                    v-model="invoiceNumber"
                />
              </div>
            </div>
            <div>
              <div class="float-child-four">

                <SaxxText
                    name="cardNumber"
                    size="150"
                    :form="formName"
                    :hide-label="true"
                    placeholder="Card number*"
                    required
                />
              </div>
              <div class="float-child-four">
                <SaxxSelect
                    name="expirationMonth"
                    :items="months"
                    :form="formName"
                    :hide-label="true"
                    placeholder="month*"
                    :change="handleMonthChange"
                ></SaxxSelect>
                <span v-if="monthError" style="color: red;">Please select a month</span>
              </div>
              <div class="float-child-four">
              <SaxxSelect
                    name="expirationYear"
                    :items="years"
                    :form="formName"
                    :hide-label="true"
                    placeholder="Year*"
                    :change="handleYearChange"
                ></SaxxSelect>
                <span v-if="yearError" style="color: red;">Please select a month</span>

              </div>

              <div class="float-child-four">
                <SaxxText
                    name="cvd"
                    size="50"
                    :form="formName"
                    :hide-label="true"
                    placeholder="Card cvd*"
                    required
                />
              </div>
            </div>

              <div>
                <div class="float-child-one">
                  <p class="customer-info">ADDRESS INFORMATION &nbsp<small>*Mandatory field </small></p>
                </div>
              </div>
              <div>
                <div class="float-child">
                  <SaxxText
                      name="firstName"
                      size="320"
                      :form="formName"
                      :hide-label="true"
                      placeholder="First name on card*"
                      required
                  />
                </div>
                <div class="float-child">
                  <SaxxText
                      name="lastName"
                      size="320"
                      :form="formName"
                      :hide-label="true"
                      placeholder="Last name on card*"
                      required
                  />
                </div>
              </div>

            <div>
              <div class="float-child">
                <SaxxText
                    name="email"
                    :form="formName"
                    :hide-label="true"
                    placeholder="Email*"
                    v-model="email"
                    required
                />
              </div>
              <div class="float-child">
                <SaxxText
                    name="phoneNumber"
                    :form="formName"
                    :hide-label="true"
                    placeholder="Phone Number*"
                    required
                />
              </div>
            </div>
            <div>
              <div class="float-child-one">
                <SaxxText
                    name="addressLine"
                    :form="formName"
                    :hide-label="true"
                    placeholder="Address*"
                    required
                />
              </div>
            </div>
            <div>
              <div class="float-child">
                <SaxxText
                    name="city"
                    :form="formName"
                    :hide-label="true"
                    placeholder="City*"
                    required
                />
              </div>
              <div class="float-child">
                <SaxxText
                    name="zipCode"
                    :form="formName"
                    :hide-label="true"
                    placeholder="Zip/Postal Code*"
                />
              </div>
            </div>
            <div>
              <div class="float-child">
                <select class="el-input__inner"
                    name="country"
                    id="country"
                    :form="formName"
                    v-model="selectedCountry"
                    @change="validateCountry"
                >
<!--                  <option disabled value="" class="el-select-dropdown__item">Country*</option>-->
                  <option value="" class="el-select-dropdown__item" disabled selected hidden>Country*</option>
                  <option value="ca"  class="el-select-dropdown__item">Canada</option>
                  <option value="us"  class="el-select-dropdown__item">United States</option>

                </select>
                <span v-if="countryError" style="color: red;">Please select a country</span>
              </div>
              <div class="float-child">
                <select
                    name="region"
                    id="region"
                    class="el-input__inner"
                    :form="formName"
                    v-model="selectedRegion"
                    @change="validateRegion"
                >
                  <option :value="defaultRegionOption.value" :disabled="selectedRegion !== ''">{{ defaultRegionOption.label }}</option>
                  <option v-for="region in filteredRegions" :key="region.value" :value="region.value">
                    {{ region.label }}
                  </option>
                </select>
                <span v-if="regionError" style="color: red;">Please select a region</span>
              </div>
            </div>
            <div>
              <div class="float-child-one">
                &nbsp;
              </div>
              <div class="float-child-one">
                  <textarea
                      id="comments"
                      name="comments"
                      v-model="comments"
                      placeholder="Comments"
                      :form="formName"
                      class="styledTextarea fullWidth form-group form-group--float form-group--active"
                      rows="7"
                  ></textarea>
              </div>
            </div>
            <div>
              <div class="float-child-one">
              <button
                    class="btn btn-saxx"
                    type="submit"
                    :disabled="isLoading"
                >Submit
                </button>
              </div>
              <div class="float-child-one">
                &nbsp;
              </div>
            </div>
          </section>
        </form>
      </div>
    </main>
  </div>
</template>

<script>
  import Vue from "vue";
  import {mapActions, mapGetters} from "vuex";
  import {notify, notifyClose} from "../../utils";
  import {language} from '../../lang';

  import SaxxText from "../forms/SaxxText";
  import SaxxSelect from "../forms/SaxxSelect";
  import {ErrorlessRepository as axios} from "../../repositories/Repository";
  import {VueReCaptcha} from 'vue-recaptcha-v3'



  export default {
    name: "ThirdPartyPayment",
    components: {
      SaxxSelect,
      SaxxText,
      VueReCaptcha
    },
    props: {
      lang: {
        required: false,
        type: String,
        default: "en",
      },
    },
    created() {
      this.checkQueryString();
      this.placeholderCurrencyText = 'Amount(usd)*';
      if (this.$route.query.country === 'ca') {
        this.placeholderCurrencyText = 'Amount(cad)*';
      }

      this.createForm({
        name: this.formName,
        fields: {
          ...this.additionalFields,
          amount: "",
          invoiceNumber: this.$route.query.trnOrderNumber ? this.$route.query.trnOrderNumber : '',
          firstName: "",
          lastName: "",
          cardNumber: "",
          expirationYear: "",
          expirationMonth: "",
          cvd: "",
          name: "",
          email: this.$route.query.ordEmailAddress ? this.$route.query.ordEmailAddress : '',
          phoneNumber: "",
          addressLine: "",
          addressLine2: "",
          city: "",
          zipCode: "",
          country: "",
          region: "",
          comments: "",
        }
      });
    },
    data() {
      const currentYear = new Date().getFullYear();
      const futureYears = 12;
      const years = Array.from({ length: futureYears }, (_, index) => {
        const value = currentYear + index;
        return {
          value: value.toString(),
          label: value.toString(),
        };
      });
      return {
        monthError: false,
        yearError: false,
        regionError: false,
        countryError: false,
        email: '',
        invoiceNumber: '',
        placeholderCurrencyText: '',
        years,
        selectedYear: currentYear,
        months: [
          { value: "1", label: "01" },
          { value: "2", label: "02" },
          { value: "3", label: "03" },
          { value: "4", label: "04" },
          { value: "5", label: "05" },
          { value: "6", label: "06" },
          { value: "7", label: "07" },
          { value: "8", label: "08" },
          { value: "9", label: "09" },
          { value: "10", label: "10" },
          { value: "11", label: "11" },
          { value: "12", label: "12" },
        ],
        formName: "b2b.payment",
        errors: false,
        acceptConfig: null,
        countries: [
          { value: "ca", label: "Canada" },
          { value: "us", label: "United States" },
        ],
        comments: "",
        selectedCountry: "",
        selectedRegion: "",
        defaultRegionOption: { value: "", label: "Region*" },
        regions: {
          ca: [
            { value: "on", label: "Ontario" },
            { value: "qc", label: "Quebec" },
            { value: "bc", label: "British Columbia" },
            { value: "ab", label: "Alberta" },
            { value: "mb", label: "Manitoba" },
            { value: "sk", label: "Saskatchewan" },
            { value: "nb", label: "New Brunswick" },
            { value: "nl", label: "Newfoundland and Labrador" },
            { value: "ns", label: "Nova Scotia" },
            { value: "pe", label: "Prince Edward Island" },
            { value: "nt", label: "Northwest Territories" },
            { value: "yt", label: "Yukon" },
            { value: "nu", label: "Nunavut" },
          ],
          us: [
            { value: "al", label: "Alabama" },
            { value: "ak", label: "Alaska" },
            { value: "az", label: "Arizona" },
            { value: "ar", label: "Arkansas" },
            { value: "ca", label: "California" },
            { value: "co", label: "Colorado" },
            { value: "ct", label: "Connecticut" },
            { value: "de", label: "Delaware" },
            { value: "fl", label: "Florida" },
            { value: "ga", label: "Georgia" },
            { value: "hi", label: "Hawaii" },
            { value: "id", label: "Idaho" },
            { value: "il", label: "Illinois" },
            { value: "in", label: "Indiana" },
            { value: "ia", label: "Iowa" },
            { value: "ks", label: "Kansas" },
            { value: "ky", label: "Kentucky" },
            { value: "la", label: "Louisiana" },
            { value: "me", label: "Maine" },
            { value: "md", label: "Maryland" },
            { value: "ma", label: "Massachusetts" },
            { value: "mi", label: "Michigan" },
            { value: "mn", label: "Minnesota" },
            { value: "ms", label: "Mississippi" },
            { value: "mo", label: "Missouri" },
            { value: "mt", label: "Montana" },
            { value: "ne", label: "Nebraska" },
            { value: "nv", label: "Nevada" },
            { value: "nh", label: "New Hampshire" },
            { value: "nj", label: "New Jersey" },
            { value: "nm", label: "New Mexico" },
            { value: "ny", label: "New York" },
            { value: "nc", label: "North Carolina" },
            { value: "nd", label: "North Dakota" },
            { value: "oh", label: "Ohio" },
            { value: "ok", label: "Oklahoma" },
            { value: "or", label: "Oregon" },
            { value: "pa", label: "Pennsylvania" },
            { value: "ri", label: "Rhode Island" },
            { value: "sc", label: "South Carolina" },
            { value: "sd", label: "South Dakota" },
            { value: "tn", label: "Tennessee" },
            { value: "tx", label: "Texas" },
            { value: "ut", label: "Utah" },
            { value: "vt", label: "Vermont" },
            { value: "va", label: "Virginia" },
            { value: "wa", label: "Washington" },
            { value: "wv", label: "West Virginia" },
            { value: "wi", label: "Wisconsin" },
            { value: "wy", label: "Wyoming" },
            { value: "dc", label: "District of Columbia" },
            { value: "as", label: "American Samoa" },
            { value: "gu", label: "Guam" },
            { value: "mp", label: "Northern Mariana Islands" },
            { value: "pr", label: "Puerto Rico" },
            { value: "vi", label: "U.S. Virgin Islands" },
          ],
        },
      };
    },
    async mounted() {
      Vue.use(VueReCaptcha, {siteKey: '6Lc1W3McAAAAAFVPsovPd8M9Dh-K-3LMzL3DWRIS'});
      this.onCountryChange(this.selectedCountry);
      this.selectedRegion = this.defaultRegionOption.value;
      await this.initAcceptJs();
    },
    methods: {
      checkQueryString() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (!urlParams.get('country') || !urlParams.get('trnOrderNumber') || !urlParams.get('ref1') || !urlParams.get('ref2') || !urlParams.get('ordEmailAddress')) {
          this.errors = 'Please go to the Customer Information page and complete the form.';
          this.errors += "\n\nClose this dialog box and the page will redirect there.";
        }
      },
      handleMonthChange(value) {
        this.monthError = false;
      },
      handleYearChange(value) {
        this.yearError = false;
      },
      validateRegion() {
        this.regionError = this.selectedRegion === '';
      },
      validateCountry() {
        this.countryError = this.selectedCountry === '';
      },
      redirectAfterClosed() {
        window.location.replace('/b2bpmt');
      },
      ...mapActions("forms", [
        "setStatus",
        "setFields",
        "setErrors",
        "setDisabledFields",
        "createForm",
      ]),
      onCountryChange(newCountry) {
        this.selectedCountry = newCountry;
        this.selectedRegion = "";
      },
      async initAcceptJs() {
        try {
          const urlParams = new URLSearchParams(window.location.search);
          const country = urlParams.get('country');
          const response = await axios.get('/credit-dashboard/authnet/client-config', {
            params: { country },
          });
          this.acceptConfig = response.data;
          await this.loadScript(this.acceptConfig.jsUrl);
        } catch (error) {
          notify('Unable to initialize the secure payment form. Please refresh the page. ' +
              'If the problem persists, contact us.', 'danger');
        }
      },
      loadScript(src) {
        return new Promise((resolve, reject) => {
          if (!src) {
            reject(new Error('Missing Accept.js URL'));
            return;
          }
          // Accept.js MUST be served from Authorize.net's own domain — bundling it locally
          // would break the PCI scope reduction.
          if (document.querySelector(`script[src="${src}"]`)) {
            resolve();
            return;
          }
          const script = document.createElement('script');
          script.src = src;
          script.charset = 'utf-8';
          script.onload = () => resolve();
          script.onerror = () => reject(new Error('Failed to load Accept.js'));
          document.head.appendChild(script);
        });
      },
      tokenize() {
        // Send the raw card data straight from the browser to Authorize.net and get back a
        // single-use nonce. Our server never sees the PAN/CVV/expiry.
        return new Promise((resolve, reject) => {
          if (!window.Accept || !this.acceptConfig) {
            reject(new Error('The secure payment form is not ready yet. Please wait a moment and try again.'));
            return;
          }
          const secureData = {
            authData: {
              clientKey: this.acceptConfig.clientKey,
              apiLoginID: this.acceptConfig.apiLoginId,
            },
            cardData: {
              cardNumber: String(this.fields.cardNumber || '').replace(/\s+/g, ''),
              month: this.fields.expirationMonth,
              year: this.fields.expirationYear,
              cardCode: this.fields.cvd,
              zip: this.fields.zipCode,
              fullName: `${this.fields.firstName || ''} ${this.fields.lastName || ''}`.trim(),
            },
          };
          window.Accept.dispatchData(secureData, (response) => {
            if (response.messages.resultCode === 'Error') {
              reject(new Error(response.messages.message.map(m => m.text).join('\n')));
              return;
            }
            resolve(response.opaqueData);
          });
        });
      },
      async submit() {
        if (!this.fields.expirationMonth) {
          this.monthError = true;
          document.querySelector('[name="expirationMonth"]').scrollIntoView();
          return;
        }
        if (!this.fields.expirationYear) {
          this.yearError = true;
          document.querySelector('[name="expirationYear"]').scrollIntoView();
          return;
        }
        if (this.selectedCountry === '') {
          this.countryError = true;
          return;
        }
        if (this.selectedRegion === '') {
          this.regionError = true;
          return;
        }
        await this.$recaptchaLoaded();
        const token = await this.$recaptcha('authnet');

        if (!this.$refs.formElement.checkValidity()) {
          return this.$refs.formElement.reportValidity();
        }
        this.setErrors({
          form: this.formName,
          errors: [],
        });
        this.setStatus({
          form: this.formName,
          status: "loading"
        });

        // Tokenize the card with Accept.js first. A failure here means the card data never
        // left the browser as a nonce; show the error and stop (a nonce is single-use, so a
        // retry must re-tokenize rather than resend a stale value).
        let opaqueData;
        try {
          opaqueData = await this.tokenize();
        } catch (error) {
          notify(error.message || 'Your card could not be validated. Please check your card details and try again.',
              'danger');
          this.setStatus({
            form: this.formName,
            status: "submitted"
          });
          return;
        }

        try {
          // Build the payload from the form fields WITHOUT any raw card data.
          const safeFields = {...this.fields};
          ['cardNumber', 'cvd', 'expirationMonth', 'expirationYear'].forEach(key => delete safeFields[key]);
          let formdata = this.toFormData(safeFields);
          // Belt-and-suspenders: guarantee no raw card field is ever sent to our server.
          ['cardNumber', 'cvd', 'expirationMonth', 'expirationYear'].forEach(key => formdata.delete(key));

          const urlParams = new URLSearchParams(window.location.search);
          formdata.append('opaqueDataDescriptor', opaqueData.dataDescriptor);
          formdata.append('opaqueDataValue', opaqueData.dataValue);
          formdata.append('google', token);
          formdata.append('region', this.selectedRegion);
          formdata.append('country', urlParams.get('country'));
          formdata.append('selectedCountry', this.selectedCountry);
          formdata.append('comments', this.comments);
          formdata.append('customerId', this.$route.query.ref1 ? this.$route.query.ref1 : '');
          formdata.append('storeName', this.$route.query.ref2 ? this.$route.query.ref2 : '');
          const response = await axios.post(
              `/credit-dashboard/authnet/thirdPartyPayment`,
              formdata,
              {
                headers: {"content-type": "multipart/form-data"}
              }
          );
          if (typeof response.data == 'undefined' || typeof response.data.status == 'undefined') {
            notify('Server error, please try again later. If you keep getting this message, please contact us.',
                'danger');
            this.setStatus({
              form: this.formName,
              status: "submitted"
            });
            return;
          }

          if (response.data.status == 'success') {
            const query = {
              trnApproved: response.data.trnApproved,
              trnId: response.data.transId,
              trnDate: response.data.trnDate,
              messageId: response.data.messageId,
              messageText: response.data.messageText,
            };
            const queryString = Object.entries(query)
                .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value == null ? '' : value)}`)
                .join('&');
            window.location.replace(`/b2b/en/authnet-feedback?${queryString}`);
          }
        } catch (error) {

          if (error?.response?.data?.errors) {
            let errors = error.response.data.errors;
            let errorString = ''
            Object.values(errors).forEach((fieldErrors) => {
              fieldErrors.forEach((errorMessage) => {
                errorString += errorMessage + "\n";
              })
            });
            notify(errorString, 'danger');

          } else if (error?.response?.data?.error_code || error?.response?.data?.message) {
            const errorString = error.response.data.error_code + "\n\n" + error.response.data.message;
            notify(errorString, 'danger');

          } else {
            notify('Server error, please try again later. If you keep getting this message, please contact us.',
                'danger');
          }


          this.setStatus({
            form: this.formName,
            status: "submitted"
          });
        }
      },
      toFormData(fields) {
        let form = new FormData();
        Object.keys(fields).forEach(key => {
          const val = fields[key];
          if (val === null) {
            return;
          }

          if (Array.isArray(val)) {
            val.forEach((v, index) => form.append(`${key}[${index}]`, v));
            return;
          }

          if (typeof val === "boolean") {
            return form.append(key, Number(val));
          }

          if (typeof val === "string" && val.trim() === "") {
            return;
          }

          form.append(key, val);
        });

        return form;
      },
    },
    computed: {
      ...mapGetters("forms", ["getStatus", "getFields"]),
      language() {
        const lang = language(this.lang);

        return lang.creditDashboard;
      },
      isSubmitted() {
        return this.getStatus({form: this.formName}) === "submitted";
      },
      isLoading() {
        return this.getStatus({form: this.formName}) === "loading";
      },
      fields() {
        return this.getFields({
          form: this.formName
        });
      },
      filteredRegions() {
        return this.selectedCountry ? this.regions[this.selectedCountry] || [] : [];
      },
    },
    watch: {
      selectedCountry(newCountry) {
        this.selectedRegion = "";
      },
      isSubmitted(val) {
        if (!val) {
          return;
        }
      }
    }
  };
</script>
<style scoped>
  .float-child {
    width: 50%;
    float: left;
  }
  .float-child-one {
    width: 100%;
    float: left;
  }
  .float-child-three {
    width: 33.3%;
    float: left;
  }
  .fullWidth {
    width: 100%;
  }
  .float-child-four {
    width: 25%;
    float: left;
  }
  .styledTextarea {
    border: 1px solid lightgray;
  }
  .error-dialog-body {
    white-space: pre-line;
  }
</style>
